export default __webpack_public_path__ + "static/media/sircleBlackWithWhiteRing.cda51674.svg";